import { useContext } from 'react';

import { XYChartOverlayPerformanceContext } from '../context/XYChartOverlayPerformance.context.js';

export const useOverlayPerformance = () => {
  const context = useContext(XYChartOverlayPerformanceContext);

  if (context === undefined) {
    throw new Error(
      'useOverlayPerformance must be used within a XYChartOverlayPerformanceContext',
    );
  }

  return context;
};
